<template>
  <div class="case-studies-carousel">
    <Carousel :components="[Hawk, Libra, Wolf, Melania, Trump, Yzy]" />
    <link
      v-for="img in allImages"
      :key="img"
      rel="preload"
      as="image"
      fetchpriority="low"
      :href="img"
    />
  </div>
</template>

<script>
import Carousel from "@/components/atoms/Carousel.vue";
import Hawk from "@/components/organisms/CaseStudies/studies/Hawk.vue";
import Libra from "@/components/organisms/CaseStudies/studies/Libra.vue";
import Wolf from "@/components/organisms/CaseStudies/studies/Wolf.vue";
import Melania from "@/components/organisms/CaseStudies/studies/Melania.vue";
import Trump from "@/components/organisms/CaseStudies/studies/Trump.vue";
import Yzy from "@/components/organisms/CaseStudies/studies/Yzy.vue";

export default {
  components: {
    Carousel,
  },
  data() {
    return {
      Hawk,
      Libra,
      Wolf,
      Melania,
      Trump,
      Yzy,
      allImages: [
        require("@/assets/logos/hawk.png"),
        require("@/assets/screenshots/hawk.png"),
        require("@/assets/logos/libra.png"),
        require("@/assets/screenshots/libra.png"),
        require("@/assets/logos/hayden.png"),
        require("@/assets/screenshots/wolf.png"),
        require("@/assets/logos/melania.png"),
        require("@/assets/screenshots/melania.png"),
        require("@/assets/logos/trump.png"),
        require("@/assets/screenshots/trump.png"),
        require("@/assets/logos/yzy.png"),
        require("@/assets/screenshots/yzy.png"),
        require("@/assets/logos/medias/fortune.png"),
        require("@/assets/logos/medias/newyorkpost.png"),
        require("@/assets/logos/medias/forbes.png"),
        require("@/assets/logos/medias/newyorktimes.png"),
        require("@/assets/logos/medias/coindesk.png"),
        require("@/assets/logos/medias/wikipedia.png"),
        require("@/assets/logos/medias/financialtimes.png"),
        require("@/assets/logos/medias/yahoo.png"),
        require("@/assets/logos/medias/decrypt.png"),
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.case-studies-carousel {
  padding: 100px 20px;
}
</style>
